import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ServiceSubscriptionCollection, SubscriptionService } from 'taxtank-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserRoleGuard  {
  constructor(private subscriptionService: SubscriptionService, private dialog: MatDialog) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.subscriptionService.get().pipe(
      map(subscriptions => this.check(subscriptions, route))
    );
  }

  /**
   * If redirection was made through the application interface (via routerLink), leave it on the current page.
   * otherwise redirect the user to the dashboard.
   */
  private check(subscriptions: ServiceSubscriptionCollection, route: ActivatedRouteSnapshot): boolean {
    // if the current subscription has no related item - forbid to go to desired page
    if (subscriptions.hasRoles(route.data.role)) {
      return true;
    }

    if (!route.data.dialog403) {
      return;
    }
    // Any redirect closes all dialogs. Need to open dialog after
    this.dialog.open(route.data.dialog403, {
      panelClass: 'dialog-banner',
      disableClose: true,
    });

    return false;
  }
}
